import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Button,
  Loader,
  Icon,
  Modal
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { getAuthActionLabel, getAuthProviderLabel, getWorkStatusLabel } from '../../helpers/user';
import { DateTimeInput } from 'semantic-ui-calendar-react-17';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class AccessScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        username: null,
        period: '',
        request: {
          username: '',
          date: '',          
        },
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, username, period, request } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchAccess({ page, username, startDate, endDate, orderBy: "Id", export: isExport ? true : null, ascending: false }));
  }

  handleChange(field, data) {    
    const { request } = this.state;    
    request[field] = data;    
    this.setState({ request, page: 1 });    
    this.handleSearchDebounced();
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { request } = this.state;
    let payload = {
      username: request.username,
      date: moment(request.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
    };

    dispatch(reportActions.create(payload)).then(() => {
      this.fetchRegisters()
    });    
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;    

    return (
      <Fragment>
        <Header>
          <h1>Logs Autenticação</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Período'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleChange("username", data.value)} loading={loading} />            
            
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>            
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>                                      
                    <Table.HeaderCell>Data</Table.HeaderCell>                      
                    <Table.HeaderCell>Usuário</Table.HeaderCell>                    
                    <Table.HeaderCell>Username</Table.HeaderCell>
                    <Table.HeaderCell>IP</Table.HeaderCell>                                  
                    <Table.HeaderCell>Evento</Table.HeaderCell>                    
                    <Table.HeaderCell>Provedor</Table.HeaderCell>
                    <Table.HeaderCell>Mensagem</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>              
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>                 
                        <Table.Cell>{register.Date ? moment(register.Date).format('DD/MM/YYYY HH:mm:ss') : '-'}</Table.Cell>    
                        <Table.Cell>{register.User?.Name}</Table.Cell>                           
                        <Table.Cell>{register.Username}</Table.Cell>              
                        <Table.Cell>{register.Ip}</Table.Cell>               
                        <Table.Cell>{getAuthActionLabel(register.Action)}</Table.Cell>               
                        <Table.Cell>{getAuthProviderLabel(register.Action)}</Table.Cell>               
                        <Table.Cell>{register.Log ?? '-'}</Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;  

  
  return {
    registers: report?.access || null,
    loading: report?.access?.loading
  };
}

const connectedAccessScreen = connect(mapStateToProps)(AccessScreen);
export { connectedAccessScreen as AccessScreen };
